export default {
  operatedBy: 'Operated by',
  partlyOperatedBy: 'Partly operated by',
  operatedByGerman: '',
}
